import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icon_checklist_line_plus.png'


const _hoisted_1 = { class: "pantry-pr-food-page" }
const _hoisted_2 = { class: "pantry-pr-food-page-area" }
const _hoisted_3 = { class: "pantry-pr-food-page-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-pr-food-page-image-icon-shopping",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "pantry-pr-food-page-recommend-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryPRFoodView = _resolveComponent("PantryPRFoodView")
  const _component_PantryRecommendTitle = _resolveComponent("PantryRecommendTitle")
  const _component_PantryRecommendView = _resolveComponent("PantryRecommendView")
  const _component_PantryRecommendMainView = _resolveComponent("PantryRecommendMainView")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "pantry-pr-food-page-menu-view-favorite",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickFavrite(...args)))
        }, [
          _createVNode("img", {
            class: "pantry-pr-food-page-image-icon-favorite",
            src: _ctx.favoriteImage
          }, null, 8, ["src"])
        ]),
        _createVNode("div", {
          class: "pantry-pr-food-page-menu-view",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickShopList(...args)))
        }, [
          _hoisted_4
        ])
      ]),
      _createVNode(_component_PantryPRFoodView, {
        key: _ctx.updateRecipeFoodsKey,
        data: _ctx.recipeFoodsData,
        onSelectBanner: _ctx.onSelectBanner
      }, null, 8, ["data", "onSelectBanner"]),
      _withDirectives(_createVNode(_component_PantryRecommendTitle, {
        class: "pantry-pr-food-page-recommend-title",
        title: 'おすすめレシピ',
        type: _ctx.PANTRY_RECIPE_TYPE.RECOMMEND,
        onSelectSeeMore: _ctx.clickSeeMore
      }, null, 8, ["type", "onSelectSeeMore"]), [
        [_vShow, _ctx.isShowRecommendList()]
      ]),
      _withDirectives(_createVNode(_component_PantryRecommendView, {
        class: "pantry-pr-food-page-recommned-view",
        recipes: _ctx.recommendRecipes,
        onSelectRecipe: _ctx.onSelectRecipe
      }, null, 8, ["recipes", "onSelectRecipe"]), [
        [_vShow, _ctx.isShowRecommendList()]
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode(_component_PantryRecommendMainView, {
        recipes: _ctx.recommendRecipes,
        onClickClose: _ctx.onCloseRecommend,
        onSelectRecipe: _ctx.onSelectRecipe
      }, null, 8, ["recipes", "onClickClose", "onSelectRecipe"])
    ], 512), [
      [_vShow, _ctx.isShowRecommend]
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}